<template>
<v-list-tile v-if="isEditable" @click="edit">
	<v-list-tile-action>
		<v-icon small>fa-edit</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Edit</v-list-tile-title>
		<v-list-tile-sub-title small>Make changes to this entry</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionDelay",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),

		isEditable () {
			return this.row.entity.isEditableBy(this.user);
		}
	},

	methods: {
		edit () {
			// TODO
			console.log("EDIT ACTION HANDLER");
		}
	}
};

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionEdit.vue